import { randomUUID } from 'node:crypto'
import { createMiddleware } from 'hono/factory'
import type { NexusEnv } from '../types.js'

/**
 * Assigns a unique request ID and correlation ID to each request.
 * - X-Request-Id: always a new UUID (or pass-through from load balancer)
 * - X-Correlation-ID: propagated from upstream or falls back to request ID
 */
export const requestIdMiddleware = createMiddleware<NexusEnv>(async (c, next) => {
  const requestId = c.req.header('X-Request-Id') ?? randomUUID()
  const correlationId = c.req.header('X-Correlation-ID') ?? requestId
  c.set('requestId', requestId)
  c.set('correlationId', correlationId)
  c.header('X-Request-ID', requestId)
  c.header('X-Correlation-ID', correlationId)
  await next()
})
